import { Button } from '@mui/material';
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import { exportCsvDataMetaculture } from 'services/API/Cooperative';
import { ThemeProvider } from '@mui/material/styles';
import { exportFileAsCSV } from 'utils/tools_functions';
import { useTranslation } from 'react-i18next';

const Export = () => {
  const { t } = useTranslation();
  const downloadFile = async () => {
    const response = await exportCsvDataMetaculture();
    exportFileAsCSV(response, 'assolia_cultures_export');
  };

  return (
    <div className="wrapper-export">
      <h1 className="title_section">{t('button.download')}</h1>
      <div>
        <ThemeProvider theme={customButtonTheme}>
          <Button onClick={() => downloadFile()}>{t('button.downloadCulturesFile')}</Button>
        </ThemeProvider>
      </div>
    </div>
  );
};

export default Export;
